export type AppPermission =
  | 'terceros.ver'
  | 'terceros.crear'
  | 'terceros.editar'
  | 'terceros.asignar_responsable'
  | 'cuestionarios.ver'
  | 'cuestionarios.crear_editar'
  | 'cuestionarios.enviar_a_tercero'
  | 'cuestionarios.revisar_respuestas'
  | 'evaluaciones.ver'
  | 'evaluaciones.crear'
  | 'evaluaciones.editar'
  | 'evaluaciones.aprobar_rechazar'
  | 'screening.ver_resultados'
  | 'screening.ejecutar'
  | 'tareas.ver'
  | 'tareas.crear_asignar'
  | 'tareas.completar'
  | 'descarga.exportar_reportes'
  | 'descarga.descargar_expedientes'
  | 'descarga.ver_resumenes'
  | 'usuarios.ver'
  | 'usuarios.crear_editar'
  | 'usuarios.gestionar_grupos';

export type AppRole = 'Administrador' | 'Manager' | 'Colaborador' | 'Supervisor';

const ALL_PERMISSIONS: AppPermission[] = [
  'terceros.ver',
  'terceros.crear',
  'terceros.editar',
  'terceros.asignar_responsable',
  'cuestionarios.ver',
  'cuestionarios.crear_editar',
  'cuestionarios.enviar_a_tercero',
  'cuestionarios.revisar_respuestas',
  'evaluaciones.ver',
  'evaluaciones.crear',
  'evaluaciones.editar',
  'evaluaciones.aprobar_rechazar',
  'screening.ver_resultados',
  'screening.ejecutar',
  'tareas.ver',
  'tareas.crear_asignar',
  'tareas.completar',
  'descarga.exportar_reportes',
  'descarga.descargar_expedientes',
  'descarga.ver_resumenes',
  'usuarios.ver',
  'usuarios.crear_editar',
  'usuarios.gestionar_grupos',
];

// Mirrors backend PermissionsSeeder. Roles in PascalCase as stored in Spatie (guard: api).
export const ROLE_PERMISSIONS: Record<AppRole, AppPermission[]> = {
  Administrador: ALL_PERMISSIONS,
  Manager: [
    'terceros.ver',
    'terceros.crear',
    'terceros.editar',
    'terceros.asignar_responsable',
    'cuestionarios.ver',
    'cuestionarios.enviar_a_tercero',
    'cuestionarios.revisar_respuestas',
    'evaluaciones.ver',
    'evaluaciones.crear',
    'evaluaciones.editar',
    // Sin 'evaluaciones.aprobar_rechazar': el Manager no evalúa. La fase en_evaluacion
    // (scoring y dictamen) es solo del Administrador. Espeja el PermissionsSeeder.
    'tareas.ver',
    'tareas.crear_asignar',
    'tareas.completar',
    'descarga.exportar_reportes',
    'descarga.descargar_expedientes',
    'descarga.ver_resumenes',
  ],
  Colaborador: [
    'terceros.ver',
    'terceros.crear',
    'terceros.editar',
    'cuestionarios.ver',
    'cuestionarios.enviar_a_tercero',
    'cuestionarios.revisar_respuestas',
    'evaluaciones.ver',
    'evaluaciones.crear',
    'evaluaciones.editar',
    'tareas.ver',
    'tareas.crear_asignar',
    'tareas.completar',
  ],
  Supervisor: [
    'terceros.ver',
    'cuestionarios.ver',
    'cuestionarios.revisar_respuestas',
    'evaluaciones.ver',
    'tareas.ver',
    'descarga.ver_resumenes',
  ],
};

export function getPermissionsForRole(role: string | string[] | undefined): AppPermission[] {
  if (!role) return [];
  const roles = Array.isArray(role) ? role : [role];
  const permSet = new Set<AppPermission>();
  for (const r of roles) {
    const perms = ROLE_PERMISSIONS[r as AppRole] ?? [];
    perms.forEach((p) => permSet.add(p));
  }
  return Array.from(permSet);
}
